// extracted by mini-css-extract-plugin
module.exports = {"homePage":"Home_homePage__2AdWy","water":"Home_water__3veu8","explore":"Home_explore__bh4-N"};